/*
  Kundi Pets — Escape cierra la búsqueda predictiva.

  El componente <predictive-search> de Dawn gestiona flechas y Enter, pero no Escape (en Dawn el
  buscador vive en una ventana modal que se cierra con Escape; la barra visible del header no).
  Aquí solo se añade ese caso usando el propio método close() de Dawn, que quita la selección,
  aria-activedescendant y aria-expanded. Se conservan el texto escrito y el foco en el campo.
  Si el panel ya está cerrado, Escape mantiene su comportamiento nativo del campo de búsqueda.
*/
(function () {
  const attach = (element) => {
    if (element.dataset.kundiEscape) return;
    element.dataset.kundiEscape = 'true';

    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !element.isOpen || typeof element.close !== 'function') return;
      // Evita que la misma pulsación borre el texto (comportamiento nativo de input type="search")
      event.preventDefault();
      element.close(false);
      if (element.input) element.input.focus();
    });
  };

  document.querySelectorAll('predictive-search').forEach(attach);
})();
